import "./Loader.scss";
import "react-circular-progressbar/dist/styles.css";

import { Box, Container, Text, VStack } from "@chakra-ui/react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { translation } from "../../utils/translation";

function Loader() {
  const intl = useIntl();

  let [percentage, setPercentage] = useState(0);
  let [text, setText] = useState(translation("general.loader.initialText"));

  let navigate = useNavigate();

  useEffect(() => {
    if (percentage > 60) {
      setText(translation("general.loader.text"));
    }

    if (percentage === 100) {
      navigate("../complete", { replace: true });
    }

    if (percentage < 100) {
      const interval = setInterval(() => {
        setPercentage((percentage) => percentage + 10);
      }, 300);
      return () => clearInterval(interval);
    }
  }, [intl, percentage, navigate]);

  return (
    <Container
      display={"flex"}
      height={["calc(100vh - 58px - 32px)", "calc(100vh - 70px - 32px)"]}
      alignItems={"center"}
      justifyContent={"center"}
      className="loader-page"
    >
      <VStack>
        <Box width={200} height={200} mb={5}>
          <CircularProgressbar
            value={percentage}
            text={`${percentage}%`}
            styles={buildStyles({
              pathColor: `rgba(108, 162, 216, ${percentage / 100})`,
              textColor: "#000000",
            })}
          />
        </Box>
        <Text
          px={30}
          fontSize={"large"}
          fontWeight={"bold"}
          textAlign={"center"}
        >
          {text}
        </Text>
      </VStack>
    </Container>
  );
}

export default Loader;
